var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUs(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_65_12938)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.5 17C13.1944 17 17 13.1944 17 8.5C17 3.80558 13.1944 0 8.5 0C3.80558 0 0 3.80558 0 8.5C0 13.1944 3.80558 17 8.5 17Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.13021 8.49999H16.9998C16.9998 7.7328 16.8975 6.98959 16.7069 6.28259H8.13021V8.49999Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.13021 4.06482H15.7522C15.2319 3.21575 14.5666 2.46526 13.7909 1.84741H8.13021V4.06482Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.4998 17C10.5002 17 12.3389 16.3086 13.7909 15.1522H3.20868C4.66065 16.3086 6.49934 17 8.4998 17Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.24741 12.9341H15.7523C16.17 12.2525 16.494 11.5074 16.707 10.7167H0.292656C0.50572 11.5074 0.829683 12.2525 1.24741 12.9341Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.93736 1.32739H4.71196L3.99145 1.85084L4.26667 2.69782L3.54619 2.17437L2.82572 2.69782L3.06345 1.96612C2.42907 2.49455 1.87305 3.11366 1.41485 3.80348H1.66304L1.20441 4.13668C1.13296 4.25588 1.06443 4.37697 0.99875 4.49985L1.21776 5.17391L0.80916 4.87704C0.707592 5.09223 0.614689 5.31227 0.531184 5.53689L0.772471 6.27957H1.66304L0.942537 6.80302L1.21776 7.65L0.497283 7.12655L0.065709 7.44012C0.0225117 7.78736 0 8.14104 0 8.5H8.5C8.5 3.80561 8.5 3.25218 8.5 0C6.82085 0 5.25556 0.48709 3.93736 1.32739ZM4.26667 7.65L3.54619 7.12655L2.82572 7.65L3.10094 6.80302L2.38043 6.27957H3.27101L3.54619 5.4326L3.82138 6.27957H4.71196L3.99145 6.80302L4.26667 7.65ZM3.99145 4.32693L4.26667 5.17391L3.54619 4.65046L2.82572 5.17391L3.10094 4.32693L2.38043 3.80348H3.27101L3.54619 2.95651L3.82138 3.80348H4.71196L3.99145 4.32693ZM7.31558 7.65L6.5951 7.12655L5.87463 7.65L6.14985 6.80302L5.42934 6.27957H6.31992L6.5951 5.4326L6.87029 6.27957H7.76087L7.04036 6.80302L7.31558 7.65ZM7.04036 4.32693L7.31558 5.17391L6.5951 4.65046L5.87463 5.17391L6.14985 4.32693L5.42934 3.80348H6.31992L6.5951 2.95651L6.87029 3.80348H7.76087L7.04036 4.32693ZM7.04036 1.85084L7.31558 2.69782L6.5951 2.17437L5.87463 2.69782L6.14985 1.85084L5.42934 1.32739H6.31992L6.5951 0.480416L6.87029 1.32739H7.76087L7.04036 1.85084Z",
    fill: "#0052B4"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_65_12938"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 17,
    height: 17,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUs);
export default __webpack_public_path__ + "static/media/US.41dc3ab41d2babb1173a806ee8cd7d2c.svg";
export { ForwardRef as ReactComponent };